import http from '../api/http';
import {
  API_FICHAS_TECNICAS,
  API_FICHAS_TECNICAS_CUSTO_DETALHADO,
  API_FICHAS_TECNICAS_INSUMOS,
  API_FICHAS_TECNICAS_SUBPROCESSOS,
  API_FICHAS_TECNICAS_SUBPRODUTOS,
} from '../api/apiConfig';
import { createCrudService } from './crudFactory';
import {
  FichaTecnica,
  FichaInsumo,
  FichaSubproduto,
  FichaSubprocesso,
  FichaCustoDetalhado,
} from '../types/fichas';

const mapListResponse = <T>(data: unknown): T[] => {
  if (Array.isArray(data)) {
    return data as T[];
  }
  if (data && typeof data === 'object' && 'results' in data) {
    return ((data as any).results ?? []) as T[];
  }
  return [];
};

export const fichasTecnicasService = createCrudService<FichaTecnica>(API_FICHAS_TECNICAS);

export const fichaTecnicaService = {
  ...fichasTecnicasService,

  getInsumos: async (fichaId: number | string): Promise<FichaInsumo[]> => {
    const response = await http.get(API_FICHAS_TECNICAS_INSUMOS(fichaId));
    return mapListResponse<FichaInsumo>(response.data);
  },

  getSubprodutos: async (fichaId: number | string): Promise<FichaSubproduto[]> => {
    const response = await http.get(API_FICHAS_TECNICAS_SUBPRODUTOS(fichaId));
    return mapListResponse<FichaSubproduto>(response.data);
  },

  getSubprocessos: async (fichaId: number | string): Promise<FichaSubprocesso[]> => {
    const response = await http.get(API_FICHAS_TECNICAS_SUBPROCESSOS(fichaId));
    return mapListResponse<FichaSubprocesso>(response.data);
  },

  getCustoDetalhado: async (fichaId: number | string): Promise<FichaCustoDetalhado> => {
    const response = await http.get<FichaCustoDetalhado>(API_FICHAS_TECNICAS_CUSTO_DETALHADO(fichaId));
    return response.data;
  },
};
